import { put, all, takeLatest, call, select } from 'redux-saga/effects';
import _isEmpty from 'lodash/isEmpty';
import _forEach from 'lodash/forEach';
import { getIrisPromotionalBannerData } from 'yoda-interfaces/lib/PromotionalBanner/IrisPromotionalBannerApi';
import * as PromotionalBannerActionTypes from '../actionTypes/PromotionalBannerActionTypes';
import { addApiResponseErrorToStore, clearErrorMsgs } from '../actions/ApiErrorAction';
import CustomErrorLogger from '../helpers/CustomErrorLogger/CustomErrorLogger';
import { selectPreferences } from '../selectors/ContextSelector';

const fetchIrisData = (response) => {
    const formattedObj = [];
    const shippingValues = {};
    if (response && response.data && response.data.content && response.data.content.components) {
        _forEach(response.data.content.components, (value) => {
            let arrObj = {};
            const {
                content: {
                    primaryText: promoText = '',
                    linkText = '',
                    link: { url: targetUrl = '' } = {},
                    openInNewTab: targetWindow = false,
                    secondaryText = '',
                    backgroundColor = '',
                    analyticsTag = '',
                    rewardPromotion = false,
                    creditCardPromotion = false,
                    rewardCustomer = '',
                    creditCustomer = '',
                },
            } = value;
            if (rewardPromotion) {
                shippingValues.rewardCustomer = rewardCustomer;
            }
            if (creditCardPromotion) {
                shippingValues.creditCustomer = creditCustomer;
            }

            arrObj = {
                promoText,
                linkText,
                targetUrl,
                targetWindow,
                secondaryText,
                backgroundColor,
                analyticsTag,
            };
            formattedObj.push(arrObj);
        });
    }
    return { content: formattedObj, shippingThresholds: shippingValues };
};

function* IrisPromotionalBannerSaga(params) {
    try {
        const response = yield call(getIrisPromotionalBannerData, params.urlParams);
        const irisPromotionalBannerData = fetchIrisData(response);
        const {
            freeShippingThresholds: { rewardCustomer = '', creditCustomer = '' } = {},
        } = yield select(selectPreferences);

        const thresholds = irisPromotionalBannerData.shippingThresholds ?? {};

        thresholds.rewardCustomer ||= rewardCustomer;
        thresholds.creditCustomer ||= creditCustomer;

        irisPromotionalBannerData.shippingThresholds = thresholds;

        if (response.status < 200 || response.status >= 300) {
            // error happened

            yield all([
                put(
                    addApiResponseErrorToStore(
                        PromotionalBannerActionTypes.IRIS_PROMOTIONALBANNERDATA_GET_ERROR
                    )
                ),
                put({
                    type:
                        PromotionalBannerActionTypes.IRIS_PROMOTIONALBANNERDATA_GET_ERROR_FSH_FALLBACK,
                    irisPromotionalBannerData,
                }),
            ]);
        } else {
            yield all([
                put(
                    clearErrorMsgs(
                        PromotionalBannerActionTypes.IRIS_PROMOTIONALBANNERDATA_GET_ERROR
                    )
                ),
                put({
                    type: PromotionalBannerActionTypes.IRIS_PROMOTIONALBANNERDATA_GET_SUCCESS,
                    irisPromotionalBannerData,
                }),
            ]);
        }
        if (_isEmpty(irisPromotionalBannerData?.content)) {
            const errorDetails = {
                errorType: 'sitepromo API failure',
                errorDescription: 'site promotions are not available',
            };
            yield put(CustomErrorLogger.triggerCustomErrorLog(errorDetails));
        }
    } catch (error) {
        const errorDetails = {
            errorType: error.errorCode || 'sitepromo API failure',
            errorDescription: error.errorMessage || 'site promotions are not available',
        };
        yield put(CustomErrorLogger.triggerCustomErrorLog(errorDetails));
        yield put({ type: 'IRIS_PROMOTIONALBANNERDATA_GET_ERROR', error });
    }
}

const watchIrisPromotionalBannerActionRequest = function* watchIrisPromotionalBannerActionRequest() {
    yield takeLatest(
        PromotionalBannerActionTypes.IRIS_PROMOTIONALBANNERDATA_GET_REQUEST,
        IrisPromotionalBannerSaga
    );
};

watchIrisPromotionalBannerActionRequest.sagaName = 'IrisPromotionalBannerSaga';

export default watchIrisPromotionalBannerActionRequest;
